import React, { useEffect, useState } from 'react';
import { Animated, Pressable } from 'react-native';
import { Image } from 'expo-image';
import { loadPetHoverImage, loadPetImage } from '@/constants/pets';
import usePetMotion from './usePetMotion';

export default function PetHero({ pet, onPress, styles, compact = false, accessibilityLabel }) {
  const [isHovered, setIsHovered] = useState(false);
  const [images, setImages] = useState({ default: null, hover: null });
  const isPetHovered = !compact && isHovered;
  const { animatedStyle, reduceMotion } = usePetMotion({
    isVisible: Boolean(images.default),
    isHovered: isPetHovered,
  });

  useEffect(() => {
    setIsHovered(false);
  }, [compact, pet]);

  useEffect(() => {
    let cancelled = false;
    setImages({ default: null, hover: null });
    loadPetImage(pet)
      .then(image => {
        if (!cancelled) setImages(current => ({ ...current, default: image }));
      })
      .catch(error => console.error(`Unable to load ${pet.name}'s hero image:`, error));
    loadPetHoverImage(pet)
      .then(image => {
        if (!cancelled) setImages(current => ({ ...current, hover: image }));
      })
      .catch(error => console.error(`Unable to load ${pet.name}'s hero hover image:`, error));
    return () => {
      cancelled = true;
    };
  }, [pet]);

  if (!images.default) return null;

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
      onHoverIn={compact ? undefined : () => setIsHovered(true)}
      onHoverOut={compact ? undefined : () => setIsHovered(false)}
      onPress={() => {
        setIsHovered(false);
        onPress();
      }}
      style={({ pressed }) => [styles.petHeroButton, pressed && { opacity: 0.82 }]}
    >
      <Animated.View pointerEvents="none" style={[styles.petHeroImage, animatedStyle]}>
        <Image
          source={isPetHovered && images.hover ? images.hover : images.default}
          style={styles.petHeroImage}
          contentFit="contain"
          transition={reduceMotion ? 0 : 100}
        />
      </Animated.View>
    </Pressable>
  );
}
